import { useEffect, useState } from "react";
import { fetchExportAdvertisers } from "../../services/exportAdvertisersService";

// The advertiser list behind QuickBooksAdvertiserPicker on the QuickBooks page's
// CSV tabs. `advertisers` is null while loading or after a failure.
export function useExportAdvertisers() {
  const [advertisers, setAdvertisers] = useState(null);
  const [advertisersError, setAdvertisersError] = useState(null);

  useEffect(() => {
    let live = true;
    fetchExportAdvertisers()
      .then((list) => { if (live) setAdvertisers(list); })
      .catch((err) => { if (live) setAdvertisersError(err?.message || "Could not load the advertisers."); });
    return () => { live = false; };
  }, []);

  return { advertisers, advertisersError };
}
